<template>
  <q-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
    <q-card class="neg-escopo neg-modal neg-modal--estreito">
      <q-card-section class="neg-modal__titulo">Data de retorno</q-card-section>

      <q-card-section class="neg-modal__corpo">
        <p class="neg-sub">
          A data sugerida vem do prazo da etapa. Troque quando o cliente pedir outro dia.
        </p>
        <q-date minimal today-btn mask="YYYY-MM-DD" :locale="langDate" v-model="data" />
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat no-caps label="Cancelar" @click="$emit('update:modelValue', false)" />
        <q-btn
          unelevated
          no-caps
          color="primary"
          label="Salvar data"
          :disable="!data"
          @click="$emit('confirmar', data)"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: "negocios-modal-data-alerta",

  emits: ["confirmar", "update:modelValue"],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    dataAtual: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      data: null
    };
  },
  watch: {
    modelValue(aberto) {
      if (aberto) {
        this.data = this.dataAtual;
      }
    }
  }
};
</script>
